import { createApp as Nr, defineComponent as We, h as rt, provide as gr, ref as H, getCurrentScope as Tr, onScopeDispose as Or, unref as Lr, onMounted as He, nextTick as Rn, readonly as kn, getCurrentInstance as Nt, watch as Se, shallowRef as Ut, computed as q, onUnmounted as Vt, inject as Fn, onBeforeMount as Mn, Fragment as wn, createVNode as vr, Text as hr } from "vue";
import { parseISO as Ir } from "date-fns";
import tt from "crypto";
function Un(e) {
  const t = document.createElement("div"), n = Nr(e), a = () => n.unmount(), s = n.mount(t);
  return s.unmount = a, s;
}
function as(e) {
  const t = We({
    setup: e,
    render() {
      return rt("div", []);
    }
  });
  return Un(t);
}
const br = Symbol("num");
function ls(e) {
  const t = We({
    setup: e,
    render() {
      return rt("div", []);
    }
  }), n = We({
    components: t,
    setup() {
      gr(br, H(1));
    },
    render() {
      return rt("div", []);
    }
  });
  return Un(n);
}
function Wt(e) {
  return Tr() ? (Or(e), !0) : !1;
}
function at(e) {
  return typeof e == "function" ? e() : Lr(e);
}
const Vn = typeof window < "u" && typeof document < "u", Ar = Object.prototype.toString, yr = (e) => Ar.call(e) === "[object Object]", bt = () => {
};
function Wn(e, t) {
  function n(...a) {
    return new Promise((s, r) => {
      Promise.resolve(e(() => t.apply(this, a), { fn: t, thisArg: this, args: a })).then(s).catch(r);
    });
  }
  return n;
}
const $n = (e) => e();
function Sr(e, t = {}) {
  let n, a, s = bt;
  const r = (u) => {
    clearTimeout(u), s(), s = bt;
  };
  return (u) => {
    const c = at(e), m = at(t.maxWait);
    return n && r(n), c <= 0 || m !== void 0 && m <= 0 ? (a && (r(a), a = null), Promise.resolve(u())) : new Promise((E, g) => {
      s = t.rejectOnCancel ? g : E, m && !a && (a = setTimeout(() => {
        n && r(n), a = null, E(u());
      }, m)), n = setTimeout(() => {
        a && r(a), a = null, E(u());
      }, c);
    });
  };
}
function Cr(e = $n) {
  const t = H(!0);
  function n() {
    t.value = !1;
  }
  function a() {
    t.value = !0;
  }
  const s = (...r) => {
    t.value && e(...r);
  };
  return { isActive: kn(t), pause: n, resume: a, eventFilter: s };
}
function Dr(e) {
  return e || Nt();
}
function Pr(e, t = 200, n = {}) {
  return Wn(
    Sr(t, n),
    e
  );
}
function Rr(e, t, n = {}) {
  const {
    eventFilter: a = $n,
    ...s
  } = n;
  return Se(
    e,
    Wn(
      a,
      t
    ),
    s
  );
}
function kr(e, t, n = {}) {
  const {
    eventFilter: a,
    ...s
  } = n, { eventFilter: r, pause: o, resume: u, isActive: c } = Cr(a);
  return { stop: Rr(
    e,
    t,
    {
      ...s,
      eventFilter: r
    }
  ), pause: o, resume: u, isActive: c };
}
function Fr(e, t = !0, n) {
  const a = Dr(n);
  a ? He(e, a) : t ? e() : Rn(e);
}
function Gn(e) {
  var t;
  const n = at(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const dt = Vn ? window : void 0, Mr = Vn ? window.navigator : void 0;
function Et(...e) {
  let t, n, a, s;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, a, s] = e, t = dt) : [t, n, a, s] = e, !t)
    return bt;
  Array.isArray(n) || (n = [n]), Array.isArray(a) || (a = [a]);
  const r = [], o = () => {
    r.forEach((E) => E()), r.length = 0;
  }, u = (E, g, N, I) => (E.addEventListener(g, N, I), () => E.removeEventListener(g, N, I)), c = Se(
    () => [Gn(t), at(s)],
    ([E, g]) => {
      if (o(), !E)
        return;
      const N = yr(g) ? { ...g } : g;
      r.push(
        ...n.flatMap((I) => a.map((D) => u(E, I, D, N)))
      );
    },
    { immediate: !0, flush: "post" }
  ), m = () => {
    c(), o();
  };
  return Wt(m), m;
}
function wr() {
  const e = H(!1);
  return Nt() && He(() => {
    e.value = !0;
  }), e;
}
function Hn(e) {
  return wr(), q(() => !!e());
}
const ft = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, mt = "__vueuse_ssr_handlers__", Ur = /* @__PURE__ */ Vr();
function Vr() {
  return mt in ft || (ft[mt] = ft[mt] || {}), ft[mt];
}
function Wr(e, t) {
  return Ur[e] || t;
}
function $r(e) {
  return e == null ? "any" : e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof Date ? "date" : typeof e == "boolean" ? "boolean" : typeof e == "string" ? "string" : typeof e == "object" ? "object" : Number.isNaN(e) ? "any" : "number";
}
const Gr = {
  boolean: {
    read: (e) => e === "true",
    write: (e) => String(e)
  },
  object: {
    read: (e) => JSON.parse(e),
    write: (e) => JSON.stringify(e)
  },
  number: {
    read: (e) => Number.parseFloat(e),
    write: (e) => String(e)
  },
  any: {
    read: (e) => e,
    write: (e) => String(e)
  },
  string: {
    read: (e) => e,
    write: (e) => String(e)
  },
  map: {
    read: (e) => new Map(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e.entries()))
  },
  set: {
    read: (e) => new Set(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e))
  },
  date: {
    read: (e) => new Date(e),
    write: (e) => e.toISOString()
  }
}, Jt = "vueuse-storage";
function Hr(e, t, n, a = {}) {
  var s;
  const {
    flush: r = "pre",
    deep: o = !0,
    listenToStorageChanges: u = !0,
    writeDefaults: c = !0,
    mergeDefaults: m = !1,
    shallow: E,
    window: g = dt,
    eventFilter: N,
    onError: I = (P) => {
      console.error(P);
    },
    initOnMounted: D
  } = a, C = (E ? Ut : H)(typeof t == "function" ? t() : t);
  if (!n)
    try {
      n = Wr("getDefaultStorage", () => {
        var P;
        return (P = dt) == null ? void 0 : P.localStorage;
      })();
    } catch (P) {
      I(P);
    }
  if (!n)
    return C;
  const y = at(t), f = $r(y), _ = (s = a.serializer) != null ? s : Gr[f], { pause: v, resume: p } = kr(
    C,
    () => b(C.value),
    { flush: r, deep: o, eventFilter: N }
  );
  return g && u && Fr(() => {
    Et(g, "storage", F), Et(g, Jt, O), D && F();
  }), D || F(), C;
  function b(P) {
    try {
      if (P == null)
        n.removeItem(e);
      else {
        const w = _.write(P), j = n.getItem(e);
        j !== w && (n.setItem(e, w), g && g.dispatchEvent(new CustomEvent(Jt, {
          detail: {
            key: e,
            oldValue: j,
            newValue: w,
            storageArea: n
          }
        })));
      }
    } catch (w) {
      I(w);
    }
  }
  function h(P) {
    const w = P ? P.newValue : n.getItem(e);
    if (w == null)
      return c && y != null && n.setItem(e, _.write(y)), y;
    if (!P && m) {
      const j = _.read(w);
      return typeof m == "function" ? m(j, y) : f === "object" && !Array.isArray(j) ? { ...y, ...j } : j;
    } else
      return typeof w != "string" ? w : _.read(w);
  }
  function O(P) {
    F(P.detail);
  }
  function F(P) {
    if (!(P && P.storageArea !== n)) {
      if (P && P.key == null) {
        C.value = y;
        return;
      }
      if (!(P && P.key !== e)) {
        v();
        try {
          (P == null ? void 0 : P.newValue) !== _.write(C.value) && (C.value = h(P));
        } catch (w) {
          I(w);
        } finally {
          P ? Rn(p) : p();
        }
      }
    }
  }
}
function Yr(e, t, n = {}) {
  const { window: a = dt, ...s } = n;
  let r;
  const o = Hn(() => a && "MutationObserver" in a), u = () => {
    r && (r.disconnect(), r = void 0);
  }, c = Se(
    () => Gn(e),
    (g) => {
      u(), o.value && a && g && (r = new MutationObserver(t), r.observe(g, s));
    },
    { immediate: !0 }
  ), m = () => r == null ? void 0 : r.takeRecords(), E = () => {
    u(), c();
  };
  return Wt(E), {
    isSupported: o,
    stop: E,
    takeRecords: m
  };
}
function xr(e = {}) {
  const {
    enableHighAccuracy: t = !0,
    maximumAge: n = 3e4,
    timeout: a = 27e3,
    navigator: s = Mr,
    immediate: r = !0
  } = e, o = Hn(() => s && "geolocation" in s), u = H(null), c = Ut(null), m = H({
    accuracy: 0,
    latitude: Number.POSITIVE_INFINITY,
    longitude: Number.POSITIVE_INFINITY,
    altitude: null,
    altitudeAccuracy: null,
    heading: null,
    speed: null
  });
  function E(D) {
    u.value = D.timestamp, m.value = D.coords, c.value = null;
  }
  let g;
  function N() {
    o.value && (g = s.geolocation.watchPosition(
      E,
      (D) => c.value = D,
      {
        enableHighAccuracy: t,
        maximumAge: n,
        timeout: a
      }
    ));
  }
  r && N();
  function I() {
    g && s && s.geolocation.clearWatch(g);
  }
  return Wt(() => {
    I();
  }), {
    isSupported: o,
    coords: m,
    locatedAt: u,
    error: c,
    resume: N,
    pause: I
  };
}
function ss() {
  const e = H(0);
  function t(u) {
    const c = getComputedStyle(document.documentElement).getPropertyValue(u).trim();
    return parseInt(c, 10);
  }
  function n() {
    e.value = window.innerWidth;
  }
  function a(u) {
    const c = t(u);
    return q(() => e.value < c);
  }
  function s(u) {
    const c = t(u);
    return q(() => e.value === c);
  }
  function r(u) {
    const c = t(u);
    return q(() => e.value > c);
  }
  He(n);
  const o = Pr(n, 100);
  return Et(window, "resize", o), Vt(() => {
    Et(window, "resize", n);
  }), {
    isSmaller: a,
    isEqual: s,
    isBigger: r
  };
}
function Kr() {
  const e = window || global, t = () => {
    const g = [];
    return Object.keys(e).forEach((N) => {
      g.push(N);
    }), g.length.toString(36);
  }, n = (g, N) => (new Array(N + 1).join("0") + g).slice(-N), a = navigator.userAgent.length.toString(36), s = n(a + t(), 4), r = e.screen.width.toString(36), o = e.screen.height.toString(36), u = e.screen.availWidth.toString(36), c = e.screen.availHeight.toString(36), m = e.screen.colorDepth.toString(36), E = e.screen.pixelDepth.toString(36);
  return `${s}${r}${o}${u}${c}${m}${E}`;
}
/*!
  * vue-router v4.2.5
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */
var qt;
(function(e) {
  e.pop = "pop", e.push = "push";
})(qt || (qt = {}));
var Qt;
(function(e) {
  e.back = "back", e.forward = "forward", e.unknown = "";
})(Qt || (Qt = {}));
var Zt;
(function(e) {
  e[e.aborted = 4] = "aborted", e[e.cancelled = 8] = "cancelled", e[e.duplicated = 16] = "duplicated";
})(Zt || (Zt = {}));
const Br = Symbol(process.env.NODE_ENV !== "production" ? "router" : "");
function jr() {
  return Fn(Br);
}
/*!
  * shared v9.8.0
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
const Te = typeof window < "u";
let ne, Ce;
if (process.env.NODE_ENV !== "production") {
  const e = Te && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (ne = (t) => {
    e.mark(t);
  }, Ce = (t, n, a) => {
    e.measure(t, n, a), e.clearMarks(n), e.clearMarks(a);
  });
}
const Xr = /\{([0-9a-zA-Z]+)\}/g;
function $t(e, ...t) {
  return t.length === 1 && W(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(Xr, (n, a) => t.hasOwnProperty(a) ? t[a] : "");
}
const de = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), Jr = (e, t, n) => qr({ l: e, k: t, s: n }), qr = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), Q = (e) => typeof e == "number" && isFinite(e), Qr = (e) => xn(e) === "[object Date]", $e = (e) => xn(e) === "[object RegExp]", gt = (e) => M(e) && Object.keys(e).length === 0, Z = Object.assign;
let zt;
const _e = () => zt || (zt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function en(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const Zr = Object.prototype.hasOwnProperty;
function lt(e, t) {
  return Zr.call(e, t);
}
const B = Array.isArray, G = (e) => typeof e == "function", S = (e) => typeof e == "string", $ = (e) => typeof e == "boolean", W = (e) => e !== null && typeof e == "object", zr = (e) => W(e) && G(e.then) && G(e.catch), Yn = Object.prototype.toString, xn = (e) => Yn.call(e), M = (e) => {
  if (!W(e))
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t.constructor === Object;
}, ea = (e) => e == null ? "" : B(e) || M(e) && e.toString === Yn ? JSON.stringify(e, null, 2) : String(e);
function ta(e, t = "") {
  return e.reduce((n, a, s) => s === 0 ? n + a : n + t + a, "");
}
const tn = 2;
function na(e, t = 0, n = e.length) {
  const a = e.split(/\r?\n/);
  let s = 0;
  const r = [];
  for (let o = 0; o < a.length; o++)
    if (s += a[o].length + 1, s >= t) {
      for (let u = o - tn; u <= o + tn || n > s; u++) {
        if (u < 0 || u >= a.length)
          continue;
        const c = u + 1;
        r.push(`${c}${" ".repeat(3 - String(c).length)}|  ${a[u]}`);
        const m = a[u].length;
        if (u === o) {
          const E = t - (s - m) + 1, g = Math.max(1, n > s ? m - E : n - t);
          r.push("   |  " + " ".repeat(E) + "^".repeat(g));
        } else if (u > o) {
          if (n > s) {
            const E = Math.max(Math.min(n - s, m), 1);
            r.push("   |  " + "^".repeat(E));
          }
          s += m + 1;
        }
      }
      break;
    }
  return r.join(`
`);
}
function Gt(e) {
  let t = e;
  return () => ++t;
}
function Oe(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const nn = {};
function ra(e) {
  nn[e] || (nn[e] = !0, Oe(e));
}
function aa() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, a) {
      const s = e.get(n);
      s && s.push(a) || e.set(n, [a]);
    },
    off(n, a) {
      const s = e.get(n);
      s && s.splice(s.indexOf(a) >>> 0, 1);
    },
    emit(n, a) {
      (e.get(n) || []).slice().map((s) => s(a)), (e.get("*") || []).slice().map((s) => s(n, a));
    }
  };
}
const _t = (e) => !W(e) || B(e);
function nt(e, t) {
  if (_t(e) || _t(t))
    throw new Error("Invalid value");
  for (const n in e)
    lt(e, n) && (_t(e[n]) || _t(t[n]) ? t[n] = e[n] : nt(e[n], t[n]));
}
/*!
  * message-compiler v9.8.0
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
function la(e, t, n) {
  return { line: e, column: t, offset: n };
}
function At(e, t, n) {
  const a = { start: e, end: t };
  return n != null && (a.source = n), a;
}
const sa = /\{([0-9a-zA-Z]+)\}/g;
function oa(e, ...t) {
  return t.length === 1 && ia(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(sa, (n, a) => t.hasOwnProperty(a) ? t[a] : "");
}
const Kn = Object.assign, rn = (e) => typeof e == "string", ia = (e) => e !== null && typeof e == "object";
function Bn(e, t = "") {
  return e.reduce((n, a, s) => s === 0 ? n + a : n + t + a, "");
}
const R = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, ca = {
  // tokenizer error messages
  [R.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [R.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [R.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [R.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [R.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [R.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [R.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [R.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [R.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [R.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [R.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [R.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [R.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [R.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [R.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [R.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function Ye(e, t, n = {}) {
  const { domain: a, messages: s, args: r } = n, o = oa((s || ca)[e] || "", ...r || []), u = new SyntaxError(String(o));
  return u.code = e, t && (u.location = t), u.domain = a, u;
}
function ua(e) {
  throw e;
}
const fa = /<\/?[\w\s="/.':;#-\/]+>/, ma = (e) => fa.test(e), me = " ", _a = "\r", z = `
`, da = "\u2028", Ea = "\u2029";
function pa(e) {
  const t = e;
  let n = 0, a = 1, s = 1, r = 0;
  const o = (O) => t[O] === _a && t[O + 1] === z, u = (O) => t[O] === z, c = (O) => t[O] === Ea, m = (O) => t[O] === da, E = (O) => o(O) || u(O) || c(O) || m(O), g = () => n, N = () => a, I = () => s, D = () => r, C = (O) => o(O) || c(O) || m(O) ? z : t[O], y = () => C(n), f = () => C(n + r);
  function _() {
    return r = 0, E(n) && (a++, s = 0), o(n) && n++, n++, s++, t[n];
  }
  function v() {
    return o(n + r) && r++, r++, t[n + r];
  }
  function p() {
    n = 0, a = 1, s = 1, r = 0;
  }
  function b(O = 0) {
    r = O;
  }
  function h() {
    const O = n + r;
    for (; O !== n; )
      _();
    r = 0;
  }
  return {
    index: g,
    line: N,
    column: I,
    peekOffset: D,
    charAt: C,
    currentChar: y,
    currentPeek: f,
    next: _,
    peek: v,
    reset: p,
    resetPeek: b,
    skipToPeek: h
  };
}
const pe = void 0, Na = ".", an = "'", ga = "tokenizer";
function Ta(e, t = {}) {
  const n = t.location !== !1, a = pa(e), s = () => a.index(), r = () => la(a.line(), a.column(), a.index()), o = r(), u = s(), c = {
    currentType: 14,
    offset: u,
    startLoc: o,
    endLoc: o,
    lastType: 14,
    lastOffset: u,
    lastStartLoc: o,
    lastEndLoc: o,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, m = () => c, { onError: E } = t;
  function g(l, i, T, ...A) {
    const k = m();
    if (i.column += T, i.offset += T, E) {
      const U = n ? At(k.startLoc, i) : null, ie = Ye(l, U, {
        domain: ga,
        args: A
      });
      E(ie);
    }
  }
  function N(l, i, T) {
    l.endLoc = r(), l.currentType = i;
    const A = { type: i };
    return n && (A.loc = At(l.startLoc, l.endLoc)), T != null && (A.value = T), A;
  }
  const I = (l) => N(
    l,
    14
    /* TokenTypes.EOF */
  );
  function D(l, i) {
    return l.currentChar() === i ? (l.next(), i) : (g(R.EXPECTED_TOKEN, r(), 0, i), "");
  }
  function C(l) {
    let i = "";
    for (; l.currentPeek() === me || l.currentPeek() === z; )
      i += l.currentPeek(), l.peek();
    return i;
  }
  function y(l) {
    const i = C(l);
    return l.skipToPeek(), i;
  }
  function f(l) {
    if (l === pe)
      return !1;
    const i = l.charCodeAt(0);
    return i >= 97 && i <= 122 || // a-z
    i >= 65 && i <= 90 || // A-Z
    i === 95;
  }
  function _(l) {
    if (l === pe)
      return !1;
    const i = l.charCodeAt(0);
    return i >= 48 && i <= 57;
  }
  function v(l, i) {
    const { currentType: T } = i;
    if (T !== 2)
      return !1;
    C(l);
    const A = f(l.currentPeek());
    return l.resetPeek(), A;
  }
  function p(l, i) {
    const { currentType: T } = i;
    if (T !== 2)
      return !1;
    C(l);
    const A = l.currentPeek() === "-" ? l.peek() : l.currentPeek(), k = _(A);
    return l.resetPeek(), k;
  }
  function b(l, i) {
    const { currentType: T } = i;
    if (T !== 2)
      return !1;
    C(l);
    const A = l.currentPeek() === an;
    return l.resetPeek(), A;
  }
  function h(l, i) {
    const { currentType: T } = i;
    if (T !== 8)
      return !1;
    C(l);
    const A = l.currentPeek() === ".";
    return l.resetPeek(), A;
  }
  function O(l, i) {
    const { currentType: T } = i;
    if (T !== 9)
      return !1;
    C(l);
    const A = f(l.currentPeek());
    return l.resetPeek(), A;
  }
  function F(l, i) {
    const { currentType: T } = i;
    if (!(T === 8 || T === 12))
      return !1;
    C(l);
    const A = l.currentPeek() === ":";
    return l.resetPeek(), A;
  }
  function P(l, i) {
    const { currentType: T } = i;
    if (T !== 10)
      return !1;
    const A = () => {
      const U = l.currentPeek();
      return U === "{" ? f(l.peek()) : U === "@" || U === "%" || U === "|" || U === ":" || U === "." || U === me || !U ? !1 : U === z ? (l.peek(), A()) : f(U);
    }, k = A();
    return l.resetPeek(), k;
  }
  function w(l) {
    C(l);
    const i = l.currentPeek() === "|";
    return l.resetPeek(), i;
  }
  function j(l) {
    const i = C(l), T = l.currentPeek() === "%" && l.peek() === "{";
    return l.resetPeek(), {
      isModulo: T,
      hasSpace: i.length > 0
    };
  }
  function X(l, i = !0) {
    const T = (k = !1, U = "", ie = !1) => {
      const fe = l.currentPeek();
      return fe === "{" ? U === "%" ? !1 : k : fe === "@" || !fe ? U === "%" ? !0 : k : fe === "%" ? (l.peek(), T(k, "%", !0)) : fe === "|" ? U === "%" || ie ? !0 : !(U === me || U === z) : fe === me ? (l.peek(), T(!0, me, ie)) : fe === z ? (l.peek(), T(!0, z, ie)) : !0;
    }, A = T();
    return i && l.resetPeek(), A;
  }
  function re(l, i) {
    const T = l.currentChar();
    return T === pe ? pe : i(T) ? (l.next(), T) : null;
  }
  function Re(l) {
    return re(l, (T) => {
      const A = T.charCodeAt(0);
      return A >= 97 && A <= 122 || // a-z
      A >= 65 && A <= 90 || // A-Z
      A >= 48 && A <= 57 || // 0-9
      A === 95 || // _
      A === 36;
    });
  }
  function oe(l) {
    return re(l, (T) => {
      const A = T.charCodeAt(0);
      return A >= 48 && A <= 57;
    });
  }
  function xe(l) {
    return re(l, (T) => {
      const A = T.charCodeAt(0);
      return A >= 48 && A <= 57 || // 0-9
      A >= 65 && A <= 70 || // A-F
      A >= 97 && A <= 102;
    });
  }
  function ke(l) {
    let i = "", T = "";
    for (; i = oe(l); )
      T += i;
    return T;
  }
  function Ke(l) {
    y(l);
    const i = l.currentChar();
    return i !== "%" && g(R.EXPECTED_TOKEN, r(), 0, i), l.next(), "%";
  }
  function ae(l) {
    let i = "";
    for (; ; ) {
      const T = l.currentChar();
      if (T === "{" || T === "}" || T === "@" || T === "|" || !T)
        break;
      if (T === "%")
        if (X(l))
          i += T, l.next();
        else
          break;
      else if (T === me || T === z)
        if (X(l))
          i += T, l.next();
        else {
          if (w(l))
            break;
          i += T, l.next();
        }
      else
        i += T, l.next();
    }
    return i;
  }
  function Fe(l) {
    y(l);
    let i = "", T = "";
    for (; i = Re(l); )
      T += i;
    return l.currentChar() === pe && g(R.UNTERMINATED_CLOSING_BRACE, r(), 0), T;
  }
  function Be(l) {
    y(l);
    let i = "";
    return l.currentChar() === "-" ? (l.next(), i += `-${ke(l)}`) : i += ke(l), l.currentChar() === pe && g(R.UNTERMINATED_CLOSING_BRACE, r(), 0), i;
  }
  function je(l) {
    y(l), D(l, "'");
    let i = "", T = "";
    const A = (U) => U !== an && U !== z;
    for (; i = re(l, A); )
      i === "\\" ? T += Xe(l) : T += i;
    const k = l.currentChar();
    return k === z || k === pe ? (g(R.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, r(), 0), k === z && (l.next(), D(l, "'")), T) : (D(l, "'"), T);
  }
  function Xe(l) {
    const i = l.currentChar();
    switch (i) {
      case "\\":
      case "'":
        return l.next(), `\\${i}`;
      case "u":
        return Me(l, i, 4);
      case "U":
        return Me(l, i, 6);
      default:
        return g(R.UNKNOWN_ESCAPE_SEQUENCE, r(), 0, i), "";
    }
  }
  function Me(l, i, T) {
    D(l, i);
    let A = "";
    for (let k = 0; k < T; k++) {
      const U = xe(l);
      if (!U) {
        g(R.INVALID_UNICODE_ESCAPE_SEQUENCE, r(), 0, `\\${i}${A}${l.currentChar()}`);
        break;
      }
      A += U;
    }
    return `\\${i}${A}`;
  }
  function ct(l) {
    y(l);
    let i = "", T = "";
    const A = (k) => k !== "{" && k !== "}" && k !== me && k !== z;
    for (; i = re(l, A); )
      T += i;
    return T;
  }
  function Je(l) {
    let i = "", T = "";
    for (; i = Re(l); )
      T += i;
    return T;
  }
  function qe(l) {
    const i = (T = !1, A) => {
      const k = l.currentChar();
      return k === "{" || k === "%" || k === "@" || k === "|" || k === "(" || k === ")" || !k || k === me ? A : k === z || k === Na ? (A += k, l.next(), i(T, A)) : (A += k, l.next(), i(!0, A));
    };
    return i(!1, "");
  }
  function ve(l) {
    y(l);
    const i = D(
      l,
      "|"
      /* TokenChars.Pipe */
    );
    return y(l), i;
  }
  function he(l, i) {
    let T = null;
    switch (l.currentChar()) {
      case "{":
        return i.braceNest >= 1 && g(R.NOT_ALLOW_NEST_PLACEHOLDER, r(), 0), l.next(), T = N(
          i,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), y(l), i.braceNest++, T;
      case "}":
        return i.braceNest > 0 && i.currentType === 2 && g(R.EMPTY_PLACEHOLDER, r(), 0), l.next(), T = N(
          i,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), i.braceNest--, i.braceNest > 0 && y(l), i.inLinked && i.braceNest === 0 && (i.inLinked = !1), T;
      case "@":
        return i.braceNest > 0 && g(R.UNTERMINATED_CLOSING_BRACE, r(), 0), T = Ee(l, i) || I(i), i.braceNest = 0, T;
      default:
        let k = !0, U = !0, ie = !0;
        if (w(l))
          return i.braceNest > 0 && g(R.UNTERMINATED_CLOSING_BRACE, r(), 0), T = N(i, 1, ve(l)), i.braceNest = 0, i.inLinked = !1, T;
        if (i.braceNest > 0 && (i.currentType === 5 || i.currentType === 6 || i.currentType === 7))
          return g(R.UNTERMINATED_CLOSING_BRACE, r(), 0), i.braceNest = 0, Ie(l, i);
        if (k = v(l, i))
          return T = N(i, 5, Fe(l)), y(l), T;
        if (U = p(l, i))
          return T = N(i, 6, Be(l)), y(l), T;
        if (ie = b(l, i))
          return T = N(i, 7, je(l)), y(l), T;
        if (!k && !U && !ie)
          return T = N(i, 13, ct(l)), g(R.INVALID_TOKEN_IN_PLACEHOLDER, r(), 0, T.value), y(l), T;
        break;
    }
    return T;
  }
  function Ee(l, i) {
    const { currentType: T } = i;
    let A = null;
    const k = l.currentChar();
    switch ((T === 8 || T === 9 || T === 12 || T === 10) && (k === z || k === me) && g(R.INVALID_LINKED_FORMAT, r(), 0), k) {
      case "@":
        return l.next(), A = N(
          i,
          8,
          "@"
          /* TokenChars.LinkedAlias */
        ), i.inLinked = !0, A;
      case ".":
        return y(l), l.next(), N(
          i,
          9,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return y(l), l.next(), N(
          i,
          10,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return w(l) ? (A = N(i, 1, ve(l)), i.braceNest = 0, i.inLinked = !1, A) : h(l, i) || F(l, i) ? (y(l), Ee(l, i)) : O(l, i) ? (y(l), N(i, 12, Je(l))) : P(l, i) ? (y(l), k === "{" ? he(l, i) || A : N(i, 11, qe(l))) : (T === 8 && g(R.INVALID_LINKED_FORMAT, r(), 0), i.braceNest = 0, i.inLinked = !1, Ie(l, i));
    }
  }
  function Ie(l, i) {
    let T = {
      type: 14
      /* TokenTypes.EOF */
    };
    if (i.braceNest > 0)
      return he(l, i) || I(i);
    if (i.inLinked)
      return Ee(l, i) || I(i);
    switch (l.currentChar()) {
      case "{":
        return he(l, i) || I(i);
      case "}":
        return g(R.UNBALANCED_CLOSING_BRACE, r(), 0), l.next(), N(
          i,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return Ee(l, i) || I(i);
      default:
        if (w(l))
          return T = N(i, 1, ve(l)), i.braceNest = 0, i.inLinked = !1, T;
        const { isModulo: k, hasSpace: U } = j(l);
        if (k)
          return U ? N(i, 0, ae(l)) : N(i, 4, Ke(l));
        if (X(l))
          return N(i, 0, ae(l));
        break;
    }
    return T;
  }
  function Qe() {
    const { currentType: l, offset: i, startLoc: T, endLoc: A } = c;
    return c.lastType = l, c.lastOffset = i, c.lastStartLoc = T, c.lastEndLoc = A, c.offset = s(), c.startLoc = r(), a.currentChar() === pe ? N(
      c,
      14
      /* TokenTypes.EOF */
    ) : Ie(a, c);
  }
  return {
    nextToken: Qe,
    currentOffset: s,
    currentPosition: r,
    context: m
  };
}
const Oa = "parser", La = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function va(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const a = parseInt(t || n, 16);
      return a <= 55295 || a >= 57344 ? String.fromCodePoint(a) : "�";
    }
  }
}
function ha(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function a(f, _, v, p, ...b) {
    const h = f.currentPosition();
    if (h.offset += p, h.column += p, n) {
      const O = t ? At(v, h) : null, F = Ye(_, O, {
        domain: Oa,
        args: b
      });
      n(F);
    }
  }
  function s(f, _, v) {
    const p = { type: f };
    return t && (p.start = _, p.end = _, p.loc = { start: v, end: v }), p;
  }
  function r(f, _, v, p) {
    p && (f.type = p), t && (f.end = _, f.loc && (f.loc.end = v));
  }
  function o(f, _) {
    const v = f.context(), p = s(3, v.offset, v.startLoc);
    return p.value = _, r(p, f.currentOffset(), f.currentPosition()), p;
  }
  function u(f, _) {
    const v = f.context(), { lastOffset: p, lastStartLoc: b } = v, h = s(5, p, b);
    return h.index = parseInt(_, 10), f.nextToken(), r(h, f.currentOffset(), f.currentPosition()), h;
  }
  function c(f, _) {
    const v = f.context(), { lastOffset: p, lastStartLoc: b } = v, h = s(4, p, b);
    return h.key = _, f.nextToken(), r(h, f.currentOffset(), f.currentPosition()), h;
  }
  function m(f, _) {
    const v = f.context(), { lastOffset: p, lastStartLoc: b } = v, h = s(9, p, b);
    return h.value = _.replace(La, va), f.nextToken(), r(h, f.currentOffset(), f.currentPosition()), h;
  }
  function E(f) {
    const _ = f.nextToken(), v = f.context(), { lastOffset: p, lastStartLoc: b } = v, h = s(8, p, b);
    return _.type !== 12 ? (a(f, R.UNEXPECTED_EMPTY_LINKED_MODIFIER, v.lastStartLoc, 0), h.value = "", r(h, p, b), {
      nextConsumeToken: _,
      node: h
    }) : (_.value == null && a(f, R.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, ce(_)), h.value = _.value || "", r(h, f.currentOffset(), f.currentPosition()), {
      node: h
    });
  }
  function g(f, _) {
    const v = f.context(), p = s(7, v.offset, v.startLoc);
    return p.value = _, r(p, f.currentOffset(), f.currentPosition()), p;
  }
  function N(f) {
    const _ = f.context(), v = s(6, _.offset, _.startLoc);
    let p = f.nextToken();
    if (p.type === 9) {
      const b = E(f);
      v.modifier = b.node, p = b.nextConsumeToken || f.nextToken();
    }
    switch (p.type !== 10 && a(f, R.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, ce(p)), p = f.nextToken(), p.type === 2 && (p = f.nextToken()), p.type) {
      case 11:
        p.value == null && a(f, R.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, ce(p)), v.key = g(f, p.value || "");
        break;
      case 5:
        p.value == null && a(f, R.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, ce(p)), v.key = c(f, p.value || "");
        break;
      case 6:
        p.value == null && a(f, R.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, ce(p)), v.key = u(f, p.value || "");
        break;
      case 7:
        p.value == null && a(f, R.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, ce(p)), v.key = m(f, p.value || "");
        break;
      default:
        a(f, R.UNEXPECTED_EMPTY_LINKED_KEY, _.lastStartLoc, 0);
        const b = f.context(), h = s(7, b.offset, b.startLoc);
        return h.value = "", r(h, b.offset, b.startLoc), v.key = h, r(v, b.offset, b.startLoc), {
          nextConsumeToken: p,
          node: v
        };
    }
    return r(v, f.currentOffset(), f.currentPosition()), {
      node: v
    };
  }
  function I(f) {
    const _ = f.context(), v = _.currentType === 1 ? f.currentOffset() : _.offset, p = _.currentType === 1 ? _.endLoc : _.startLoc, b = s(2, v, p);
    b.items = [];
    let h = null;
    do {
      const P = h || f.nextToken();
      switch (h = null, P.type) {
        case 0:
          P.value == null && a(f, R.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, ce(P)), b.items.push(o(f, P.value || ""));
          break;
        case 6:
          P.value == null && a(f, R.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, ce(P)), b.items.push(u(f, P.value || ""));
          break;
        case 5:
          P.value == null && a(f, R.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, ce(P)), b.items.push(c(f, P.value || ""));
          break;
        case 7:
          P.value == null && a(f, R.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, ce(P)), b.items.push(m(f, P.value || ""));
          break;
        case 8:
          const w = N(f);
          b.items.push(w.node), h = w.nextConsumeToken || null;
          break;
      }
    } while (_.currentType !== 14 && _.currentType !== 1);
    const O = _.currentType === 1 ? _.lastOffset : f.currentOffset(), F = _.currentType === 1 ? _.lastEndLoc : f.currentPosition();
    return r(b, O, F), b;
  }
  function D(f, _, v, p) {
    const b = f.context();
    let h = p.items.length === 0;
    const O = s(1, _, v);
    O.cases = [], O.cases.push(p);
    do {
      const F = I(f);
      h || (h = F.items.length === 0), O.cases.push(F);
    } while (b.currentType !== 14);
    return h && a(f, R.MUST_HAVE_MESSAGES_IN_PLURAL, v, 0), r(O, f.currentOffset(), f.currentPosition()), O;
  }
  function C(f) {
    const _ = f.context(), { offset: v, startLoc: p } = _, b = I(f);
    return _.currentType === 14 ? b : D(f, v, p, b);
  }
  function y(f) {
    const _ = Ta(f, Kn({}, e)), v = _.context(), p = s(0, v.offset, v.startLoc);
    return t && p.loc && (p.loc.source = f), p.body = C(_), e.onCacheKey && (p.cacheKey = e.onCacheKey(f)), v.currentType !== 14 && a(_, R.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, f[v.offset] || ""), r(p, _.currentOffset(), _.currentPosition()), p;
  }
  return { parse: y };
}
function ce(e) {
  if (e.type === 14)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function Ia(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (r) => (n.helpers.add(r), r) };
}
function ln(e, t) {
  for (let n = 0; n < e.length; n++)
    Ht(e[n], t);
}
function Ht(e, t) {
  switch (e.type) {
    case 1:
      ln(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      ln(e.items, t);
      break;
    case 6:
      Ht(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function ba(e, t = {}) {
  const n = Ia(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && Ht(e.body, n);
  const a = n.context();
  e.helpers = Array.from(a.helpers);
}
function Aa(e) {
  const t = e.body;
  return t.type === 2 ? sn(t) : t.cases.forEach((n) => sn(n)), e;
}
function sn(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const a = e.items[n];
      if (!(a.type === 3 || a.type === 9) || a.value == null)
        break;
      t.push(a.value);
    }
    if (t.length === e.items.length) {
      e.static = Bn(t);
      for (let n = 0; n < e.items.length; n++) {
        const a = e.items[n];
        (a.type === 3 || a.type === 9) && delete a.value;
      }
    }
  }
}
const ya = "minifier";
function Ue(e) {
  switch (e.t = e.type, e.type) {
    case 0:
      const t = e;
      Ue(t.body), t.b = t.body, delete t.body;
      break;
    case 1:
      const n = e, a = n.cases;
      for (let E = 0; E < a.length; E++)
        Ue(a[E]);
      n.c = a, delete n.cases;
      break;
    case 2:
      const s = e, r = s.items;
      for (let E = 0; E < r.length; E++)
        Ue(r[E]);
      s.i = r, delete s.items, s.static && (s.s = s.static, delete s.static);
      break;
    case 3:
    case 9:
    case 8:
    case 7:
      const o = e;
      o.value && (o.v = o.value, delete o.value);
      break;
    case 6:
      const u = e;
      Ue(u.key), u.k = u.key, delete u.key, u.modifier && (Ue(u.modifier), u.m = u.modifier, delete u.modifier);
      break;
    case 5:
      const c = e;
      c.i = c.index, delete c.index;
      break;
    case 4:
      const m = e;
      m.k = m.key, delete m.key;
      break;
    default:
      throw Ye(R.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: ya,
        args: [e.type]
      });
  }
  delete e.type;
}
const Sa = "parser";
function Ca(e, t) {
  const { sourceMap: n, filename: a, breakLineCode: s, needIndent: r } = t, o = t.location !== !1, u = {
    filename: a,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: s,
    needIndent: r,
    indentLevel: 0
  };
  o && e.loc && (u.source = e.loc.source);
  const c = () => u;
  function m(y, f) {
    u.code += y;
  }
  function E(y, f = !0) {
    const _ = f ? s : "";
    m(r ? _ + "  ".repeat(y) : _);
  }
  function g(y = !0) {
    const f = ++u.indentLevel;
    y && E(f);
  }
  function N(y = !0) {
    const f = --u.indentLevel;
    y && E(f);
  }
  function I() {
    E(u.indentLevel);
  }
  return {
    context: c,
    push: m,
    indent: g,
    deindent: N,
    newline: I,
    helper: (y) => `_${y}`,
    needIndent: () => u.needIndent
  };
}
function Da(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Ge(e, t.key), t.modifier ? (e.push(", "), Ge(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Pa(e, t) {
  const { helper: n, needIndent: a } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(a());
  const s = t.items.length;
  for (let r = 0; r < s && (Ge(e, t.items[r]), r !== s - 1); r++)
    e.push(", ");
  e.deindent(a()), e.push("])");
}
function Ra(e, t) {
  const { helper: n, needIndent: a } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(a());
    const s = t.cases.length;
    for (let r = 0; r < s && (Ge(e, t.cases[r]), r !== s - 1); r++)
      e.push(", ");
    e.deindent(a()), e.push("])");
  }
}
function ka(e, t) {
  t.body ? Ge(e, t.body) : e.push("null");
}
function Ge(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      ka(e, t);
      break;
    case 1:
      Ra(e, t);
      break;
    case 2:
      Pa(e, t);
      break;
    case 6:
      Da(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      throw Ye(R.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: Sa,
        args: [t.type]
      });
  }
}
const Fa = (e, t = {}) => {
  const n = rn(t.mode) ? t.mode : "normal", a = rn(t.filename) ? t.filename : "message.intl", s = !!t.sourceMap, r = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, o = t.needIndent ? t.needIndent : n !== "arrow", u = e.helpers || [], c = Ca(e, {
    mode: n,
    filename: a,
    sourceMap: s,
    breakLineCode: r,
    needIndent: o
  });
  c.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), c.indent(o), u.length > 0 && (c.push(`const { ${Bn(u.map((g) => `${g}: _${g}`), ", ")} } = ctx`), c.newline()), c.push("return "), Ge(c, e), c.deindent(o), c.push("}"), delete e.helpers;
  const { code: m, map: E } = c.context();
  return {
    ast: e,
    code: m,
    map: E ? E.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Ma(e, t = {}) {
  const n = Kn({}, t), a = !!n.jit, s = !!n.minify, r = n.optimize == null ? !0 : n.optimize, u = ha(n).parse(e);
  return a ? (r && Aa(u), s && Ue(u), { ast: u, code: "" }) : (ba(u, n), Fa(u, n));
}
/*!
  * core-base v9.8.0
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
function wa() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (_e().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (_e().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (_e().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
const Le = [];
Le[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Le[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Le[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
Le[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
Le[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
Le[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
Le[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const Ua = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function Va(e) {
  return Ua.test(e);
}
function Wa(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function $a(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function Ga(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : Va(t) ? Wa(t) : "*" + t;
}
function Ha(e) {
  const t = [];
  let n = -1, a = 0, s = 0, r, o, u, c, m, E, g;
  const N = [];
  N[
    0
    /* Actions.APPEND */
  ] = () => {
    o === void 0 ? o = u : o += u;
  }, N[
    1
    /* Actions.PUSH */
  ] = () => {
    o !== void 0 && (t.push(o), o = void 0);
  }, N[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    N[
      0
      /* Actions.APPEND */
    ](), s++;
  }, N[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (s > 0)
      s--, a = 4, N[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (s = 0, o === void 0 || (o = Ga(o), o === !1))
        return !1;
      N[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function I() {
    const D = e[n + 1];
    if (a === 5 && D === "'" || a === 6 && D === '"')
      return n++, u = "\\" + D, N[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; a !== null; )
    if (n++, r = e[n], !(r === "\\" && I())) {
      if (c = $a(r), g = Le[a], m = g[c] || g.l || 8, m === 8 || (a = m[0], m[1] !== void 0 && (E = N[m[1]], E && (u = r, E() === !1))))
        return;
      if (a === 7)
        return t;
    }
}
const on = /* @__PURE__ */ new Map();
function Ya(e, t) {
  return W(e) ? e[t] : null;
}
function xa(e, t) {
  if (!W(e))
    return null;
  let n = on.get(t);
  if (n || (n = Ha(t), n && on.set(t, n)), !n)
    return null;
  const a = n.length;
  let s = e, r = 0;
  for (; r < a; ) {
    const o = s[n[r]];
    if (o === void 0 || G(s))
      return null;
    s = o, r++;
  }
  return s;
}
const Ka = (e) => e, Ba = (e) => "", ja = "text", Xa = (e) => e.length === 0 ? "" : ta(e), Ja = ea;
function cn(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function qa(e) {
  const t = Q(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (Q(e.named.count) || Q(e.named.n)) ? Q(e.named.count) ? e.named.count : Q(e.named.n) ? e.named.n : t : t;
}
function Qa(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function Za(e = {}) {
  const t = e.locale, n = qa(e), a = W(e.pluralRules) && S(t) && G(e.pluralRules[t]) ? e.pluralRules[t] : cn, s = W(e.pluralRules) && S(t) && G(e.pluralRules[t]) ? cn : void 0, r = (f) => f[a(n, f.length, s)], o = e.list || [], u = (f) => o[f], c = e.named || {};
  Q(e.pluralIndex) && Qa(n, c);
  const m = (f) => c[f];
  function E(f) {
    const _ = G(e.messages) ? e.messages(f) : W(e.messages) ? e.messages[f] : !1;
    return _ || (e.parent ? e.parent.message(f) : Ba);
  }
  const g = (f) => e.modifiers ? e.modifiers[f] : Ka, N = M(e.processor) && G(e.processor.normalize) ? e.processor.normalize : Xa, I = M(e.processor) && G(e.processor.interpolate) ? e.processor.interpolate : Ja, D = M(e.processor) && S(e.processor.type) ? e.processor.type : ja, y = {
    list: u,
    named: m,
    plural: r,
    linked: (f, ..._) => {
      const [v, p] = _;
      let b = "text", h = "";
      _.length === 1 ? W(v) ? (h = v.modifier || h, b = v.type || b) : S(v) && (h = v || h) : _.length === 2 && (S(v) && (h = v || h), S(p) && (b = p || b));
      const O = E(f)(y), F = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        b === "vnode" && B(O) && h ? O[0] : O
      );
      return h ? g(h)(F, b) : F;
    },
    message: E,
    type: D,
    interpolate: I,
    normalize: N,
    values: Z({}, o, c)
  };
  return y;
}
let st = null;
function za(e) {
  st = e;
}
function el(e, t, n) {
  st && st.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const tl = /* @__PURE__ */ nl(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function nl(e) {
  return (t) => st && st.emit(e, t);
}
const ee = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  __EXTEND_POINT__: 8
}, rl = {
  [ee.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [ee.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [ee.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [ee.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [ee.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [ee.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [ee.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function De(e, ...t) {
  return $t(rl[e], ...t);
}
const jn = R.__EXTEND_POINT__, ye = Gt(jn), J = {
  INVALID_ARGUMENT: jn,
  INVALID_DATE_ARGUMENT: ye(),
  INVALID_ISO_DATE_ARGUMENT: ye(),
  NOT_SUPPORT_NON_STRING_MESSAGE: ye(),
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: ye(),
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: ye(),
  NOT_SUPPORT_LOCALE_TYPE: ye(),
  __EXTEND_POINT__: ye()
  // 25
};
function ue(e) {
  return Ye(e, null, process.env.NODE_ENV !== "production" ? { messages: al } : void 0);
}
const al = {
  [J.INVALID_ARGUMENT]: "Invalid arguments",
  [J.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [J.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [J.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [J.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [J.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [J.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function Yt(e, t) {
  return t.locale != null ? un(t.locale) : un(e.locale);
}
let vt;
function un(e) {
  if (S(e))
    return e;
  if (G(e)) {
    if (e.resolvedOnce && vt != null)
      return vt;
    if (e.constructor.name === "Function") {
      const t = e();
      if (zr(t))
        throw ue(J.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return vt = t;
    } else
      throw ue(J.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw ue(J.NOT_SUPPORT_LOCALE_TYPE);
}
function ll(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...B(t) ? t : W(t) ? Object.keys(t) : S(t) ? [t] : [n]
  ])];
}
function Xn(e, t, n) {
  const a = S(n) ? n : ot, s = e;
  s.__localeChainCache || (s.__localeChainCache = /* @__PURE__ */ new Map());
  let r = s.__localeChainCache.get(a);
  if (!r) {
    r = [];
    let o = [n];
    for (; B(o); )
      o = fn(r, o, t);
    const u = B(t) || !M(t) ? t : t.default ? t.default : null;
    o = S(u) ? [u] : u, B(o) && fn(r, o, !1), s.__localeChainCache.set(a, r);
  }
  return r;
}
function fn(e, t, n) {
  let a = !0;
  for (let s = 0; s < t.length && $(a); s++) {
    const r = t[s];
    S(r) && (a = sl(e, t[s], n));
  }
  return a;
}
function sl(e, t, n) {
  let a;
  const s = t.split("-");
  do {
    const r = s.join("-");
    a = ol(e, r, n), s.splice(-1, 1);
  } while (s.length && a === !0);
  return a;
}
function ol(e, t, n) {
  let a = !1;
  if (!e.includes(t) && (a = !0, t)) {
    a = t[t.length - 1] !== "!";
    const s = t.replace(/!/g, "");
    e.push(s), (B(n) || M(n)) && n[s] && (a = n[s]);
  }
  return a;
}
const il = "9.8.0", Tt = -1, ot = "en-US", pt = "", mn = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function cl() {
  return {
    upper: (e, t) => t === "text" && S(e) ? e.toUpperCase() : t === "vnode" && W(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && S(e) ? e.toLowerCase() : t === "vnode" && W(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && S(e) ? mn(e) : t === "vnode" && W(e) && "__v_isVNode" in e ? mn(e.children) : e
  };
}
let Jn;
function _n(e) {
  Jn = e;
}
let qn;
function ul(e) {
  qn = e;
}
let Qn;
function fl(e) {
  Qn = e;
}
let Zn = null;
const dn = (e) => {
  Zn = e;
}, ml = () => Zn;
let En = 0;
function _l(e = {}) {
  const t = G(e.onWarn) ? e.onWarn : Oe, n = S(e.version) ? e.version : il, a = S(e.locale) || G(e.locale) ? e.locale : ot, s = G(a) ? ot : a, r = B(e.fallbackLocale) || M(e.fallbackLocale) || S(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : s, o = M(e.messages) ? e.messages : { [s]: {} }, u = M(e.datetimeFormats) ? e.datetimeFormats : { [s]: {} }, c = M(e.numberFormats) ? e.numberFormats : { [s]: {} }, m = Z({}, e.modifiers || {}, cl()), E = e.pluralRules || {}, g = G(e.missing) ? e.missing : null, N = $(e.missingWarn) || $e(e.missingWarn) ? e.missingWarn : !0, I = $(e.fallbackWarn) || $e(e.fallbackWarn) ? e.fallbackWarn : !0, D = !!e.fallbackFormat, C = !!e.unresolving, y = G(e.postTranslation) ? e.postTranslation : null, f = M(e.processor) ? e.processor : null, _ = $(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, v = !!e.escapeParameter, p = G(e.messageCompiler) ? e.messageCompiler : Jn;
  process.env.NODE_ENV !== "production" && G(e.messageCompiler) && ra(De(ee.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const b = G(e.messageResolver) ? e.messageResolver : qn || Ya, h = G(e.localeFallbacker) ? e.localeFallbacker : Qn || ll, O = W(e.fallbackContext) ? e.fallbackContext : void 0, F = e, P = W(F.__datetimeFormatters) ? F.__datetimeFormatters : /* @__PURE__ */ new Map(), w = W(F.__numberFormatters) ? F.__numberFormatters : /* @__PURE__ */ new Map(), j = W(F.__meta) ? F.__meta : {};
  En++;
  const X = {
    version: n,
    cid: En,
    locale: a,
    fallbackLocale: r,
    messages: o,
    modifiers: m,
    pluralRules: E,
    missing: g,
    missingWarn: N,
    fallbackWarn: I,
    fallbackFormat: D,
    unresolving: C,
    postTranslation: y,
    processor: f,
    warnHtmlMessage: _,
    escapeParameter: v,
    messageCompiler: p,
    messageResolver: b,
    localeFallbacker: h,
    fallbackContext: O,
    onWarn: t,
    __meta: j
  };
  return X.datetimeFormats = u, X.numberFormats = c, X.__datetimeFormatters = P, X.__numberFormatters = w, process.env.NODE_ENV !== "production" && (X.__v_emitter = F.__v_emitter != null ? F.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && el(X, n, j), X;
}
function Ot(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function zn(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function xt(e, t, n, a, s) {
  const { missing: r, onWarn: o } = e;
  if (process.env.NODE_ENV !== "production") {
    const u = e.__v_emitter;
    u && u.emit("missing", {
      locale: n,
      key: t,
      type: s,
      groupId: `${s}:${t}`
    });
  }
  if (r !== null) {
    const u = r(e, n, t, s);
    return S(u) ? u : t;
  } else
    return process.env.NODE_ENV !== "production" && zn(a, t) && o(De(ee.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function Ze(e, t, n) {
  const a = e;
  a.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function ht(e) {
  return (n) => dl(n, e);
}
function dl(e, t) {
  const n = t.b || t.body;
  if ((n.t || n.type) === 1) {
    const a = n, s = a.c || a.cases;
    return e.plural(s.reduce((r, o) => [
      ...r,
      pn(e, o)
    ], []));
  } else
    return pn(e, n);
}
function pn(e, t) {
  const n = t.s || t.static;
  if (n)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const a = (t.i || t.items).reduce((s, r) => [...s, yt(e, r)], []);
    return e.normalize(a);
  }
}
function yt(e, t) {
  const n = t.t || t.type;
  switch (n) {
    case 3:
      const a = t;
      return a.v || a.value;
    case 9:
      const s = t;
      return s.v || s.value;
    case 4:
      const r = t;
      return e.interpolate(e.named(r.k || r.key));
    case 5:
      const o = t;
      return e.interpolate(e.list(o.i != null ? o.i : o.index));
    case 6:
      const u = t, c = u.m || u.modifier;
      return e.linked(yt(e, u.k || u.key), c ? yt(e, c) : void 0, e.type);
    case 7:
      const m = t;
      return m.v || m.value;
    case 8:
      const E = t;
      return E.v || E.value;
    default:
      throw new Error(`unhandled node type on format message part: ${n}`);
  }
}
const El = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function er(e, t) {
  t && ma(e) && Oe($t(El, { source: e }));
}
const tr = (e) => e;
let Ve = /* @__PURE__ */ Object.create(null);
const Pe = (e) => W(e) && (e.t === 0 || e.type === 0) && ("b" in e || "body" in e);
function nr(e, t = {}) {
  let n = !1;
  const a = t.onError || ua;
  return t.onError = (s) => {
    n = !0, a(s);
  }, { ...Ma(e, t), detectError: n };
}
const pl = /* @__NO_SIDE_EFFECTS__ */ (e, t) => {
  if (!S(e))
    throw ue(J.NOT_SUPPORT_NON_STRING_MESSAGE);
  {
    const n = $(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && er(e, n);
    const s = (t.onCacheKey || tr)(e), r = Ve[s];
    if (r)
      return r;
    const { code: o, detectError: u } = nr(e, t), c = new Function(`return ${o}`)();
    return u ? c : Ve[s] = c;
  }
};
function Nl(e, t) {
  if (__INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && S(e)) {
    const n = $(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && er(e, n);
    const s = (t.onCacheKey || tr)(e), r = Ve[s];
    if (r)
      return r;
    const { ast: o, detectError: u } = nr(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), c = ht(o);
    return u ? c : Ve[s] = c;
  } else {
    if (process.env.NODE_ENV !== "production" && !Pe(e))
      return Oe(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const a = Ve[n];
      return a || (Ve[n] = ht(e));
    } else
      return ht(e);
  }
}
const Nn = () => "", se = (e) => G(e);
function gn(e, ...t) {
  const { fallbackFormat: n, postTranslation: a, unresolving: s, messageCompiler: r, fallbackLocale: o, messages: u } = e, [c, m] = St(...t), E = $(m.missingWarn) ? m.missingWarn : e.missingWarn, g = $(m.fallbackWarn) ? m.fallbackWarn : e.fallbackWarn, N = $(m.escapeParameter) ? m.escapeParameter : e.escapeParameter, I = !!m.resolvedMessage, D = S(m.default) || $(m.default) ? $(m.default) ? r ? c : () => c : m.default : n ? r ? c : () => c : "", C = n || D !== "", y = Yt(e, m);
  N && gl(m);
  let [f, _, v] = I ? [
    c,
    y,
    u[y] || {}
  ] : rr(e, c, y, o, g, E), p = f, b = c;
  if (!I && !(S(p) || Pe(p) || se(p)) && C && (p = D, b = p), !I && (!(S(p) || Pe(p) || se(p)) || !S(_)))
    return s ? Tt : c;
  if (process.env.NODE_ENV !== "production" && S(p) && e.messageCompiler == null)
    return Oe(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${c}'.`), c;
  let h = !1;
  const O = () => {
    h = !0;
  }, F = se(p) ? p : ar(e, c, _, p, b, O);
  if (h)
    return p;
  const P = vl(e, _, v, m), w = Za(P), j = Tl(e, F, w), X = a ? a(j, c) : j;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const re = {
      timestamp: Date.now(),
      key: S(c) ? c : se(p) ? p.key : "",
      locale: _ || (se(p) ? p.locale : ""),
      format: S(p) ? p : se(p) ? p.source : "",
      message: X
    };
    re.meta = Z({}, e.__meta, {}), tl(re);
  }
  return X;
}
function gl(e) {
  B(e.list) ? e.list = e.list.map((t) => S(t) ? en(t) : t) : W(e.named) && Object.keys(e.named).forEach((t) => {
    S(e.named[t]) && (e.named[t] = en(e.named[t]));
  });
}
function rr(e, t, n, a, s, r) {
  const { messages: o, onWarn: u, messageResolver: c, localeFallbacker: m } = e, E = m(e, a, n);
  let g = {}, N, I = null, D = n, C = null;
  const y = "translate";
  for (let f = 0; f < E.length; f++) {
    if (N = C = E[f], process.env.NODE_ENV !== "production" && n !== N && Ot(s, t) && u(De(ee.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: N
    })), process.env.NODE_ENV !== "production" && n !== N) {
      const h = e.__v_emitter;
      h && h.emit("fallback", {
        type: y,
        key: t,
        from: D,
        to: C,
        groupId: `${y}:${t}`
      });
    }
    g = o[N] || {};
    let _ = null, v, p;
    if (process.env.NODE_ENV !== "production" && Te && (_ = window.performance.now(), v = "intlify-message-resolve-start", p = "intlify-message-resolve-end", ne && ne(v)), (I = c(g, t)) === null && (I = g[t]), process.env.NODE_ENV !== "production" && Te) {
      const h = window.performance.now(), O = e.__v_emitter;
      O && _ && I && O.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: I,
        time: h - _,
        groupId: `${y}:${t}`
      }), v && p && ne && Ce && (ne(p), Ce("intlify message resolve", v, p));
    }
    if (S(I) || Pe(I) || se(I))
      break;
    const b = xt(
      e,
      // eslint-disable-line @typescript-eslint/no-explicit-any
      t,
      N,
      r,
      y
    );
    b !== t && (I = b), D = C;
  }
  return [I, N, g];
}
function ar(e, t, n, a, s, r) {
  const { messageCompiler: o, warnHtmlMessage: u } = e;
  if (se(a)) {
    const N = a;
    return N.locale = N.locale || n, N.key = N.key || t, N;
  }
  if (o == null) {
    const N = () => a;
    return N.locale = n, N.key = t, N;
  }
  let c = null, m, E;
  process.env.NODE_ENV !== "production" && Te && (c = window.performance.now(), m = "intlify-message-compilation-start", E = "intlify-message-compilation-end", ne && ne(m));
  const g = o(a, Ol(e, n, s, a, u, r));
  if (process.env.NODE_ENV !== "production" && Te) {
    const N = window.performance.now(), I = e.__v_emitter;
    I && c && I.emit("message-compilation", {
      type: "message-compilation",
      message: a,
      time: N - c,
      groupId: `translate:${t}`
    }), m && E && ne && Ce && (ne(E), Ce("intlify message compilation", m, E));
  }
  return g.locale = n, g.key = t, g.source = a, g;
}
function Tl(e, t, n) {
  let a = null, s, r;
  process.env.NODE_ENV !== "production" && Te && (a = window.performance.now(), s = "intlify-message-evaluation-start", r = "intlify-message-evaluation-end", ne && ne(s));
  const o = t(n);
  if (process.env.NODE_ENV !== "production" && Te) {
    const u = window.performance.now(), c = e.__v_emitter;
    c && a && c.emit("message-evaluation", {
      type: "message-evaluation",
      value: o,
      time: u - a,
      groupId: `translate:${t.key}`
    }), s && r && ne && Ce && (ne(r), Ce("intlify message evaluation", s, r));
  }
  return o;
}
function St(...e) {
  const [t, n, a] = e, s = {};
  if (!S(t) && !Q(t) && !se(t) && !Pe(t))
    throw ue(J.INVALID_ARGUMENT);
  const r = Q(t) ? String(t) : (se(t), t);
  return Q(n) ? s.plural = n : S(n) ? s.default = n : M(n) && !gt(n) ? s.named = n : B(n) && (s.list = n), Q(a) ? s.plural = a : S(a) ? s.default = a : M(a) && Z(s, a), [r, s];
}
function Ol(e, t, n, a, s, r) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: s,
    onError: (o) => {
      if (r && r(o), process.env.NODE_ENV !== "production") {
        const u = Ll(a), c = `Message compilation error: ${o.message}`, m = o.location && u && na(u, o.location.start.offset, o.location.end.offset), E = e.__v_emitter;
        E && u && E.emit("compile-error", {
          message: u,
          error: o.message,
          start: o.location && o.location.start.offset,
          end: o.location && o.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(m ? `${c}
${m}` : c);
      } else
        throw o;
    },
    onCacheKey: (o) => Jr(t, n, o)
  };
}
function Ll(e) {
  if (S(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function vl(e, t, n, a) {
  const { modifiers: s, pluralRules: r, messageResolver: o, fallbackLocale: u, fallbackWarn: c, missingWarn: m, fallbackContext: E } = e, N = {
    locale: t,
    modifiers: s,
    pluralRules: r,
    messages: (I) => {
      let D = o(n, I);
      if (D == null && E) {
        const [, , C] = rr(E, I, t, u, c, m);
        D = o(C, I);
      }
      if (S(D) || Pe(D)) {
        let C = !1;
        const f = ar(e, I, t, D, I, () => {
          C = !0;
        });
        return C ? Nn : f;
      } else
        return se(D) ? D : Nn;
    }
  };
  return e.processor && (N.processor = e.processor), a.list && (N.list = a.list), a.named && (N.named = a.named), Q(a.plural) && (N.pluralIndex = a.plural), N;
}
const Tn = typeof Intl < "u", lr = {
  dateTimeFormat: Tn && typeof Intl.DateTimeFormat < "u",
  numberFormat: Tn && typeof Intl.NumberFormat < "u"
};
function On(e, ...t) {
  const { datetimeFormats: n, unresolving: a, fallbackLocale: s, onWarn: r, localeFallbacker: o } = e, { __datetimeFormatters: u } = e;
  if (process.env.NODE_ENV !== "production" && !lr.dateTimeFormat)
    return r(De(ee.CANNOT_FORMAT_DATE)), pt;
  const [c, m, E, g] = Ct(...t), N = $(E.missingWarn) ? E.missingWarn : e.missingWarn, I = $(E.fallbackWarn) ? E.fallbackWarn : e.fallbackWarn, D = !!E.part, C = Yt(e, E), y = o(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    C
  );
  if (!S(c) || c === "")
    return new Intl.DateTimeFormat(C, g).format(m);
  let f = {}, _, v = null, p = C, b = null;
  const h = "datetime format";
  for (let P = 0; P < y.length; P++) {
    if (_ = b = y[P], process.env.NODE_ENV !== "production" && C !== _ && Ot(I, c) && r(De(ee.FALLBACK_TO_DATE_FORMAT, {
      key: c,
      target: _
    })), process.env.NODE_ENV !== "production" && C !== _) {
      const w = e.__v_emitter;
      w && w.emit("fallback", {
        type: h,
        key: c,
        from: p,
        to: b,
        groupId: `${h}:${c}`
      });
    }
    if (f = n[_] || {}, v = f[c], M(v))
      break;
    xt(e, c, _, N, h), p = b;
  }
  if (!M(v) || !S(_))
    return a ? Tt : c;
  let O = `${_}__${c}`;
  gt(g) || (O = `${O}__${JSON.stringify(g)}`);
  let F = u.get(O);
  return F || (F = new Intl.DateTimeFormat(_, Z({}, v, g)), u.set(O, F)), D ? F.formatToParts(m) : F.format(m);
}
const sr = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Ct(...e) {
  const [t, n, a, s] = e, r = {};
  let o = {}, u;
  if (S(t)) {
    const c = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!c)
      throw ue(J.INVALID_ISO_DATE_ARGUMENT);
    const m = c[3] ? c[3].trim().startsWith("T") ? `${c[1].trim()}${c[3].trim()}` : `${c[1].trim()}T${c[3].trim()}` : c[1].trim();
    u = new Date(m);
    try {
      u.toISOString();
    } catch {
      throw ue(J.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (Qr(t)) {
    if (isNaN(t.getTime()))
      throw ue(J.INVALID_DATE_ARGUMENT);
    u = t;
  } else if (Q(t))
    u = t;
  else
    throw ue(J.INVALID_ARGUMENT);
  return S(n) ? r.key = n : M(n) && Object.keys(n).forEach((c) => {
    sr.includes(c) ? o[c] = n[c] : r[c] = n[c];
  }), S(a) ? r.locale = a : M(a) && (o = a), M(s) && (o = s), [r.key || "", u, r, o];
}
function Ln(e, t, n) {
  const a = e;
  for (const s in n) {
    const r = `${t}__${s}`;
    a.__datetimeFormatters.has(r) && a.__datetimeFormatters.delete(r);
  }
}
function vn(e, ...t) {
  const { numberFormats: n, unresolving: a, fallbackLocale: s, onWarn: r, localeFallbacker: o } = e, { __numberFormatters: u } = e;
  if (process.env.NODE_ENV !== "production" && !lr.numberFormat)
    return r(De(ee.CANNOT_FORMAT_NUMBER)), pt;
  const [c, m, E, g] = Dt(...t), N = $(E.missingWarn) ? E.missingWarn : e.missingWarn, I = $(E.fallbackWarn) ? E.fallbackWarn : e.fallbackWarn, D = !!E.part, C = Yt(e, E), y = o(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    C
  );
  if (!S(c) || c === "")
    return new Intl.NumberFormat(C, g).format(m);
  let f = {}, _, v = null, p = C, b = null;
  const h = "number format";
  for (let P = 0; P < y.length; P++) {
    if (_ = b = y[P], process.env.NODE_ENV !== "production" && C !== _ && Ot(I, c) && r(De(ee.FALLBACK_TO_NUMBER_FORMAT, {
      key: c,
      target: _
    })), process.env.NODE_ENV !== "production" && C !== _) {
      const w = e.__v_emitter;
      w && w.emit("fallback", {
        type: h,
        key: c,
        from: p,
        to: b,
        groupId: `${h}:${c}`
      });
    }
    if (f = n[_] || {}, v = f[c], M(v))
      break;
    xt(e, c, _, N, h), p = b;
  }
  if (!M(v) || !S(_))
    return a ? Tt : c;
  let O = `${_}__${c}`;
  gt(g) || (O = `${O}__${JSON.stringify(g)}`);
  let F = u.get(O);
  return F || (F = new Intl.NumberFormat(_, Z({}, v, g)), u.set(O, F)), D ? F.formatToParts(m) : F.format(m);
}
const or = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Dt(...e) {
  const [t, n, a, s] = e, r = {};
  let o = {};
  if (!Q(t))
    throw ue(J.INVALID_ARGUMENT);
  const u = t;
  return S(n) ? r.key = n : M(n) && Object.keys(n).forEach((c) => {
    or.includes(c) ? o[c] = n[c] : r[c] = n[c];
  }), S(a) ? r.locale = a : M(a) && (o = a), M(s) && (o = s), [r.key || "", u, r, o];
}
function hn(e, t, n) {
  const a = e;
  for (const s in n) {
    const r = `${t}__${s}`;
    a.__numberFormatters.has(r) && a.__numberFormatters.delete(r);
  }
}
wa();
/*!
  * vue-i18n v9.8.0
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
const hl = "9.8.0";
function Il() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (_e().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (_e().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (_e().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (_e().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (_e().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const ir = ee.__EXTEND_POINT__, Ne = Gt(ir), le = {
  FALLBACK_TO_ROOT: ir,
  NOT_SUPPORTED_PRESERVE: Ne(),
  NOT_SUPPORTED_FORMATTER: Ne(),
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: Ne(),
  NOT_SUPPORTED_GET_CHOICE_INDEX: Ne(),
  COMPONENT_NAME_LEGACY_COMPATIBLE: Ne(),
  NOT_FOUND_PARENT_SCOPE: Ne(),
  IGNORE_OBJ_FLATTEN: Ne(),
  NOTICE_DROP_ALLOW_COMPOSITION: Ne()
  // 17
}, bl = {
  [le.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [le.NOT_SUPPORTED_PRESERVE]: "Not supported 'preserve'.",
  [le.NOT_SUPPORTED_FORMATTER]: "Not supported 'formatter'.",
  [le.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: "Not supported 'preserveDirectiveContent'.",
  [le.NOT_SUPPORTED_GET_CHOICE_INDEX]: "Not supported 'getChoiceIndex'.",
  [le.COMPONENT_NAME_LEGACY_COMPATIBLE]: "Component name legacy compatible: '{name}' -> 'i18n'",
  [le.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [le.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [le.NOTICE_DROP_ALLOW_COMPOSITION]: "'allowComposition' option will be dropped in the next major version. For more information, please see 👉 https://tinyurl.com/2p97mcze"
};
function Kt(e, ...t) {
  return $t(bl[e], ...t);
}
const cr = J.__EXTEND_POINT__, te = Gt(cr), Y = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: cr,
  // legacy module errors
  INVALID_ARGUMENT: te(),
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: te(),
  NOT_INSTALLED: te(),
  NOT_AVAILABLE_IN_LEGACY_MODE: te(),
  // directive module errors
  REQUIRED_VALUE: te(),
  INVALID_VALUE: te(),
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: te(),
  NOT_INSTALLED_WITH_PROVIDE: te(),
  // unexpected error
  UNEXPECTED_ERROR: te(),
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: te(),
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: te(),
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: te(),
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: te(),
  // for enhancement
  __EXTEND_POINT__: te()
  // 40
};
function ge(e, ...t) {
  return Ye(e, null, process.env.NODE_ENV !== "production" ? { messages: Al, args: t } : void 0);
}
const Al = {
  [Y.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [Y.INVALID_ARGUMENT]: "Invalid argument",
  [Y.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [Y.NOT_INSTALLED]: "Need to install with `app.use` function",
  [Y.UNEXPECTED_ERROR]: "Unexpected error",
  [Y.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
  [Y.REQUIRED_VALUE]: "Required in value: {0}",
  [Y.INVALID_VALUE]: "Invalid value",
  [Y.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [Y.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [Y.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [Y.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
  [Y.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
  [Y.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Pt = /* @__PURE__ */ de("__translateVNode"), Rt = /* @__PURE__ */ de("__datetimeParts"), kt = /* @__PURE__ */ de("__numberParts"), Ft = /* @__PURE__ */ de("__enableEmitter"), Mt = /* @__PURE__ */ de("__disableEmitter"), yl = de("__setPluralRules"), ur = /* @__PURE__ */ de("__injectWithOption"), wt = /* @__PURE__ */ de("__dispose");
function it(e) {
  if (!W(e))
    return e;
  for (const t in e)
    if (lt(e, t))
      if (!t.includes("."))
        W(e[t]) && it(e[t]);
      else {
        const n = t.split("."), a = n.length - 1;
        let s = e, r = !1;
        for (let o = 0; o < a; o++) {
          if (n[o] in s || (s[n[o]] = {}), !W(s[n[o]])) {
            process.env.NODE_ENV !== "production" && Oe(Kt(le.IGNORE_OBJ_FLATTEN, {
              key: n[o]
            })), r = !0;
            break;
          }
          s = s[n[o]];
        }
        r || (s[n[a]] = e[t], delete e[t]), W(s[n[a]]) && it(s[n[a]]);
      }
  return e;
}
function Bt(e, t) {
  const { messages: n, __i18n: a, messageResolver: s, flatJson: r } = t, o = M(n) ? n : B(a) ? {} : { [e]: {} };
  if (B(a) && a.forEach((u) => {
    if ("locale" in u && "resource" in u) {
      const { locale: c, resource: m } = u;
      c ? (o[c] = o[c] || {}, nt(m, o[c])) : nt(m, o);
    } else
      S(u) && nt(JSON.parse(u), o);
  }), s == null && r)
    for (const u in o)
      lt(o, u) && it(o[u]);
  return o;
}
function Sl(e) {
  return e.type;
}
function Cl(e, t, n) {
  let a = W(t.messages) ? t.messages : {};
  "__i18nGlobal" in n && (a = Bt(e.locale.value, {
    messages: a,
    __i18n: n.__i18nGlobal
  }));
  const s = Object.keys(a);
  s.length && s.forEach((r) => {
    e.mergeLocaleMessage(r, a[r]);
  });
  {
    if (W(t.datetimeFormats)) {
      const r = Object.keys(t.datetimeFormats);
      r.length && r.forEach((o) => {
        e.mergeDateTimeFormat(o, t.datetimeFormats[o]);
      });
    }
    if (W(t.numberFormats)) {
      const r = Object.keys(t.numberFormats);
      r.length && r.forEach((o) => {
        e.mergeNumberFormat(o, t.numberFormats[o]);
      });
    }
  }
}
function In(e) {
  return vr(hr, null, e, 0);
}
const bn = () => [], Dl = () => !1;
let An = 0;
function yn(e) {
  return (t, n, a, s) => e(n, a, Nt() || void 0, s);
}
function Pl(e = {}, t) {
  const { __root: n, __injectWithOption: a } = e, s = n === void 0, r = e.flatJson;
  let o = $(e.inheritLocale) ? e.inheritLocale : !0;
  const u = H(
    // prettier-ignore
    n && o ? n.locale.value : S(e.locale) ? e.locale : ot
  ), c = H(
    // prettier-ignore
    n && o ? n.fallbackLocale.value : S(e.fallbackLocale) || B(e.fallbackLocale) || M(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : u.value
  ), m = H(Bt(u.value, e)), E = H(M(e.datetimeFormats) ? e.datetimeFormats : { [u.value]: {} }), g = H(M(e.numberFormats) ? e.numberFormats : { [u.value]: {} });
  let N = n ? n.missingWarn : $(e.missingWarn) || $e(e.missingWarn) ? e.missingWarn : !0, I = n ? n.fallbackWarn : $(e.fallbackWarn) || $e(e.fallbackWarn) ? e.fallbackWarn : !0, D = n ? n.fallbackRoot : $(e.fallbackRoot) ? e.fallbackRoot : !0, C = !!e.fallbackFormat, y = G(e.missing) ? e.missing : null, f = G(e.missing) ? yn(e.missing) : null, _ = G(e.postTranslation) ? e.postTranslation : null, v = n ? n.warnHtmlMessage : $(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, p = !!e.escapeParameter;
  const b = n ? n.modifiers : M(e.modifiers) ? e.modifiers : {};
  let h = e.pluralRules || n && n.pluralRules, O;
  O = (() => {
    s && dn(null);
    const d = {
      version: hl,
      locale: u.value,
      fallbackLocale: c.value,
      messages: m.value,
      modifiers: b,
      pluralRules: h,
      missing: f === null ? void 0 : f,
      missingWarn: N,
      fallbackWarn: I,
      fallbackFormat: C,
      unresolving: !0,
      postTranslation: _ === null ? void 0 : _,
      warnHtmlMessage: v,
      escapeParameter: p,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    d.datetimeFormats = E.value, d.numberFormats = g.value, d.__datetimeFormatters = M(O) ? O.__datetimeFormatters : void 0, d.__numberFormatters = M(O) ? O.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (d.__v_emitter = M(O) ? O.__v_emitter : void 0);
    const L = _l(d);
    return s && dn(L), L;
  })(), Ze(O, u.value, c.value);
  const P = q({
    get: () => u.value,
    set: (d) => {
      u.value = d, O.locale = u.value;
    }
  }), w = q({
    get: () => c.value,
    set: (d) => {
      c.value = d, O.fallbackLocale = c.value, Ze(O, u.value, d);
    }
  }), j = q(() => m.value), X = /* @__PURE__ */ q(() => E.value), re = /* @__PURE__ */ q(() => g.value);
  function Re() {
    return G(_) ? _ : null;
  }
  function oe(d) {
    _ = d, O.postTranslation = d;
  }
  function xe() {
    return y;
  }
  function ke(d) {
    d !== null && (f = yn(d)), y = d, O.missing = f;
  }
  function Ke(d, L) {
    return d !== "translate" || !L.resolvedMessage;
  }
  const ae = (d, L, V, x, be, ut) => {
    let we;
    try {
      s || (O.fallbackContext = n ? ml() : void 0), we = d(O);
    } finally {
      s || (O.fallbackContext = void 0);
    }
    if (V !== "translate exists" && // for not `te` (e.g `t`)
    Q(we) && we === Tt || V === "translate exists" && !we) {
      const [Ae, pr] = L();
      if (process.env.NODE_ENV !== "production" && n && S(Ae) && Ke(V, pr) && (D && (Ot(I, Ae) || zn(N, Ae)) && Oe(Kt(le.FALLBACK_TO_ROOT, {
        key: Ae,
        type: V
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Xt } = O;
        Xt && D && Xt.emit("fallback", {
          type: V,
          key: Ae,
          to: "global",
          groupId: `${V}:${Ae}`
        });
      }
      return n && D ? x(n) : be(Ae);
    } else {
      if (ut(we))
        return we;
      throw ge(Y.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Fe(...d) {
    return ae((L) => Reflect.apply(gn, null, [L, ...d]), () => St(...d), "translate", (L) => Reflect.apply(L.t, L, [...d]), (L) => L, (L) => S(L));
  }
  function Be(...d) {
    const [L, V, x] = d;
    if (x && !W(x))
      throw ge(Y.INVALID_ARGUMENT);
    return Fe(L, V, Z({ resolvedMessage: !0 }, x || {}));
  }
  function je(...d) {
    return ae((L) => Reflect.apply(On, null, [L, ...d]), () => Ct(...d), "datetime format", (L) => Reflect.apply(L.d, L, [...d]), () => pt, (L) => S(L));
  }
  function Xe(...d) {
    return ae((L) => Reflect.apply(vn, null, [L, ...d]), () => Dt(...d), "number format", (L) => Reflect.apply(L.n, L, [...d]), () => pt, (L) => S(L));
  }
  function Me(d) {
    return d.map((L) => S(L) || Q(L) || $(L) ? In(String(L)) : L);
  }
  const Je = {
    normalize: Me,
    interpolate: (d) => d,
    type: "vnode"
  };
  function qe(...d) {
    return ae(
      (L) => {
        let V;
        const x = L;
        try {
          x.processor = Je, V = Reflect.apply(gn, null, [x, ...d]);
        } finally {
          x.processor = null;
        }
        return V;
      },
      () => St(...d),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (L) => L[Pt](...d),
      (L) => [In(L)],
      (L) => B(L)
    );
  }
  function ve(...d) {
    return ae(
      (L) => Reflect.apply(vn, null, [L, ...d]),
      () => Dt(...d),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (L) => L[kt](...d),
      bn,
      (L) => S(L) || B(L)
    );
  }
  function he(...d) {
    return ae(
      (L) => Reflect.apply(On, null, [L, ...d]),
      () => Ct(...d),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (L) => L[Rt](...d),
      bn,
      (L) => S(L) || B(L)
    );
  }
  function Ee(d) {
    h = d, O.pluralRules = h;
  }
  function Ie(d, L) {
    return ae(() => {
      if (!d)
        return !1;
      const V = S(L) ? L : u.value, x = i(V), be = O.messageResolver(x, d);
      return Pe(be) || se(be) || S(be);
    }, () => [d], "translate exists", (V) => Reflect.apply(V.te, V, [d, L]), Dl, (V) => $(V));
  }
  function Qe(d) {
    let L = null;
    const V = Xn(O, c.value, u.value);
    for (let x = 0; x < V.length; x++) {
      const be = m.value[V[x]] || {}, ut = O.messageResolver(be, d);
      if (ut != null) {
        L = ut;
        break;
      }
    }
    return L;
  }
  function l(d) {
    const L = Qe(d);
    return L ?? (n ? n.tm(d) || {} : {});
  }
  function i(d) {
    return m.value[d] || {};
  }
  function T(d, L) {
    if (r) {
      const V = { [d]: L };
      for (const x in V)
        lt(V, x) && it(V[x]);
      L = V[d];
    }
    m.value[d] = L, O.messages = m.value;
  }
  function A(d, L) {
    m.value[d] = m.value[d] || {};
    const V = { [d]: L };
    for (const x in V)
      lt(V, x) && it(V[x]);
    L = V[d], nt(L, m.value[d]), O.messages = m.value;
  }
  function k(d) {
    return E.value[d] || {};
  }
  function U(d, L) {
    E.value[d] = L, O.datetimeFormats = E.value, Ln(O, d, L);
  }
  function ie(d, L) {
    E.value[d] = Z(E.value[d] || {}, L), O.datetimeFormats = E.value, Ln(O, d, L);
  }
  function fe(d) {
    return g.value[d] || {};
  }
  function dr(d, L) {
    g.value[d] = L, O.numberFormats = g.value, hn(O, d, L);
  }
  function Er(d, L) {
    g.value[d] = Z(g.value[d] || {}, L), O.numberFormats = g.value, hn(O, d, L);
  }
  An++, n && Te && (Se(n.locale, (d) => {
    o && (u.value = d, O.locale = d, Ze(O, u.value, c.value));
  }), Se(n.fallbackLocale, (d) => {
    o && (c.value = d, O.fallbackLocale = d, Ze(O, u.value, c.value));
  }));
  const K = {
    id: An,
    locale: P,
    fallbackLocale: w,
    get inheritLocale() {
      return o;
    },
    set inheritLocale(d) {
      o = d, d && n && (u.value = n.locale.value, c.value = n.fallbackLocale.value, Ze(O, u.value, c.value));
    },
    get availableLocales() {
      return Object.keys(m.value).sort();
    },
    messages: j,
    get modifiers() {
      return b;
    },
    get pluralRules() {
      return h || {};
    },
    get isGlobal() {
      return s;
    },
    get missingWarn() {
      return N;
    },
    set missingWarn(d) {
      N = d, O.missingWarn = N;
    },
    get fallbackWarn() {
      return I;
    },
    set fallbackWarn(d) {
      I = d, O.fallbackWarn = I;
    },
    get fallbackRoot() {
      return D;
    },
    set fallbackRoot(d) {
      D = d;
    },
    get fallbackFormat() {
      return C;
    },
    set fallbackFormat(d) {
      C = d, O.fallbackFormat = C;
    },
    get warnHtmlMessage() {
      return v;
    },
    set warnHtmlMessage(d) {
      v = d, O.warnHtmlMessage = d;
    },
    get escapeParameter() {
      return p;
    },
    set escapeParameter(d) {
      p = d, O.escapeParameter = d;
    },
    t: Fe,
    getLocaleMessage: i,
    setLocaleMessage: T,
    mergeLocaleMessage: A,
    getPostTranslationHandler: Re,
    setPostTranslationHandler: oe,
    getMissingHandler: xe,
    setMissingHandler: ke,
    [yl]: Ee
  };
  return K.datetimeFormats = X, K.numberFormats = re, K.rt = Be, K.te = Ie, K.tm = l, K.d = je, K.n = Xe, K.getDateTimeFormat = k, K.setDateTimeFormat = U, K.mergeDateTimeFormat = ie, K.getNumberFormat = fe, K.setNumberFormat = dr, K.mergeNumberFormat = Er, K[ur] = a, K[Pt] = qe, K[Rt] = he, K[kt] = ve, process.env.NODE_ENV !== "production" && (K[Ft] = (d) => {
    O.__v_emitter = d;
  }, K[Mt] = () => {
    O.__v_emitter = void 0;
  }), K;
}
const jt = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function Rl({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((a, s) => [
    ...a,
    // prettier-ignore
    ...s.type === wn ? s.children : [s]
  ], []) : t.reduce((n, a) => {
    const s = e[a];
    return s && (n[a] = s()), n;
  }, {});
}
function fr(e) {
  return wn;
}
Z({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validator: (e) => Q(e) || !isNaN(e)
  }
}, jt);
function kl(e) {
  return B(e) && !S(e[0]);
}
function mr(e, t, n, a) {
  const { slots: s, attrs: r } = t;
  return () => {
    const o = { part: !0 };
    let u = {};
    e.locale && (o.locale = e.locale), S(e.format) ? o.key = e.format : W(e.format) && (S(e.format.key) && (o.key = e.format.key), u = Object.keys(e.format).reduce((N, I) => n.includes(I) ? Z({}, N, { [I]: e.format[I] }) : N, {}));
    const c = a(e.value, o, u);
    let m = [o.key];
    B(c) ? m = c.map((N, I) => {
      const D = s[N.type], C = D ? D({ [N.type]: N.value, index: I, parts: c }) : [N.value];
      return kl(C) && (C[0].key = `${N.type}-${I}`), C;
    }) : S(c) && (m = [c]);
    const E = Z({}, r), g = S(e.tag) || W(e.tag) ? e.tag : fr();
    return rt(g, E, m);
  };
}
Z({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, jt);
Z({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, jt);
function Sn(e, t) {
}
const Fl = /* @__PURE__ */ de("global-vue-i18n");
function Lt(e = {}) {
  const t = Nt();
  if (t == null)
    throw ge(Y.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw ge(Y.NOT_INSTALLED);
  const n = Ml(t), a = Ul(n), s = Sl(t), r = wl(e, s);
  if (__VUE_I18N_LEGACY_API__ && n.mode === "legacy" && !e.__useComponent) {
    if (!n.allowComposition)
      throw ge(Y.NOT_AVAILABLE_IN_LEGACY_MODE);
    return Gl(t, r, a, e);
  }
  if (r === "global")
    return Cl(a, e, s), a;
  if (r === "parent") {
    let c = Vl(n, t, e.__useComponent);
    return c == null && (process.env.NODE_ENV !== "production" && Oe(Kt(le.NOT_FOUND_PARENT_SCOPE)), c = a), c;
  }
  const o = n;
  let u = o.__getInstance(t);
  if (u == null) {
    const c = Z({}, e);
    "__i18n" in s && (c.__i18n = s.__i18n), a && (c.__root = a), u = Pl(c), o.__composerExtend && (u[wt] = o.__composerExtend(u)), $l(o, t, u), o.__setInstance(t, u);
  }
  return u;
}
function Ml(e) {
  {
    const t = Fn(e.isCE ? Fl : e.appContext.app.__VUE_I18N_SYMBOL__);
    if (!t)
      throw ge(e.isCE ? Y.NOT_INSTALLED_WITH_PROVIDE : Y.UNEXPECTED_ERROR);
    return t;
  }
}
function wl(e, t) {
  return gt(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function Ul(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function Vl(e, t, n = !1) {
  let a = null;
  const s = t.root;
  let r = Wl(t, n);
  for (; r != null; ) {
    const o = e;
    if (e.mode === "composition")
      a = o.__getInstance(r);
    else if (__VUE_I18N_LEGACY_API__) {
      const u = o.__getInstance(r);
      u != null && (a = u.__composer, n && a && !a[ur] && (a = null));
    }
    if (a != null || s === r)
      break;
    r = r.parent;
  }
  return a;
}
function Wl(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function $l(e, t, n) {
  let a = null;
  He(() => {
    if ((process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = n, a = aa();
      const s = n;
      s[Ft] && s[Ft](a), a.on("*", Sn);
    }
  }, t), Vt(() => {
    const s = n;
    (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && t.vnode.el && t.vnode.el.__VUE_I18N__ && (a && a.off("*", Sn), s[Mt] && s[Mt](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const r = s[wt];
    r && (r(), delete s[wt]);
  }, t);
}
function Gl(e, t, n, a = {}) {
  const s = t === "local", r = Ut(null);
  if (s && e.proxy && !(e.proxy.$options.i18n || e.proxy.$options.__i18n))
    throw ge(Y.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
  const o = $(a.inheritLocale) ? a.inheritLocale : !S(a.locale), u = H(
    // prettier-ignore
    !s || o ? n.locale.value : S(a.locale) ? a.locale : ot
  ), c = H(
    // prettier-ignore
    !s || o ? n.fallbackLocale.value : S(a.fallbackLocale) || B(a.fallbackLocale) || M(a.fallbackLocale) || a.fallbackLocale === !1 ? a.fallbackLocale : u.value
  ), m = H(Bt(u.value, a)), E = H(M(a.datetimeFormats) ? a.datetimeFormats : { [u.value]: {} }), g = H(M(a.numberFormats) ? a.numberFormats : { [u.value]: {} }), N = s ? n.missingWarn : $(a.missingWarn) || $e(a.missingWarn) ? a.missingWarn : !0, I = s ? n.fallbackWarn : $(a.fallbackWarn) || $e(a.fallbackWarn) ? a.fallbackWarn : !0, D = s ? n.fallbackRoot : $(a.fallbackRoot) ? a.fallbackRoot : !0, C = !!a.fallbackFormat, y = G(a.missing) ? a.missing : null, f = G(a.postTranslation) ? a.postTranslation : null, _ = s ? n.warnHtmlMessage : $(a.warnHtmlMessage) ? a.warnHtmlMessage : !0, v = !!a.escapeParameter, p = s ? n.modifiers : M(a.modifiers) ? a.modifiers : {}, b = a.pluralRules || s && n.pluralRules, h = q({
    get: () => r.value ? r.value.locale.value : u.value,
    set: (l) => {
      r.value && (r.value.locale.value = l), u.value = l;
    }
  }), O = q({
    get: () => r.value ? r.value.fallbackLocale.value : c.value,
    set: (l) => {
      r.value && (r.value.fallbackLocale.value = l), c.value = l;
    }
  }), F = q(() => r.value ? r.value.messages.value : m.value), P = q(() => E.value), w = q(() => g.value);
  function j() {
    return r.value ? r.value.getPostTranslationHandler() : f;
  }
  function X(l) {
    r.value && r.value.setPostTranslationHandler(l);
  }
  function re() {
    return r.value ? r.value.getMissingHandler() : y;
  }
  function Re(l) {
    r.value && r.value.setMissingHandler(l);
  }
  function oe(l) {
    return l();
  }
  function xe(...l) {
    return r.value ? oe(() => Reflect.apply(r.value.t, null, [...l])) : oe(() => "");
  }
  function ke(...l) {
    return r.value ? Reflect.apply(r.value.rt, null, [...l]) : "";
  }
  function Ke(...l) {
    return r.value ? oe(() => Reflect.apply(r.value.d, null, [...l])) : oe(() => "");
  }
  function ae(...l) {
    return r.value ? oe(() => Reflect.apply(r.value.n, null, [...l])) : oe(() => "");
  }
  function Fe(l) {
    return r.value ? r.value.tm(l) : {};
  }
  function Be(l, i) {
    return r.value ? r.value.te(l, i) : !1;
  }
  function je(l) {
    return r.value ? r.value.getLocaleMessage(l) : {};
  }
  function Xe(l, i) {
    r.value && (r.value.setLocaleMessage(l, i), m.value[l] = i);
  }
  function Me(l, i) {
    r.value && r.value.mergeLocaleMessage(l, i);
  }
  function ct(l) {
    return r.value ? r.value.getDateTimeFormat(l) : {};
  }
  function Je(l, i) {
    r.value && (r.value.setDateTimeFormat(l, i), E.value[l] = i);
  }
  function qe(l, i) {
    r.value && r.value.mergeDateTimeFormat(l, i);
  }
  function ve(l) {
    return r.value ? r.value.getNumberFormat(l) : {};
  }
  function he(l, i) {
    r.value && (r.value.setNumberFormat(l, i), g.value[l] = i);
  }
  function Ee(l, i) {
    r.value && r.value.mergeNumberFormat(l, i);
  }
  const Ie = {
    get id() {
      return r.value ? r.value.id : -1;
    },
    locale: h,
    fallbackLocale: O,
    messages: F,
    datetimeFormats: P,
    numberFormats: w,
    get inheritLocale() {
      return r.value ? r.value.inheritLocale : o;
    },
    set inheritLocale(l) {
      r.value && (r.value.inheritLocale = l);
    },
    get availableLocales() {
      return r.value ? r.value.availableLocales : Object.keys(m.value);
    },
    get modifiers() {
      return r.value ? r.value.modifiers : p;
    },
    get pluralRules() {
      return r.value ? r.value.pluralRules : b;
    },
    get isGlobal() {
      return r.value ? r.value.isGlobal : !1;
    },
    get missingWarn() {
      return r.value ? r.value.missingWarn : N;
    },
    set missingWarn(l) {
      r.value && (r.value.missingWarn = l);
    },
    get fallbackWarn() {
      return r.value ? r.value.fallbackWarn : I;
    },
    set fallbackWarn(l) {
      r.value && (r.value.missingWarn = l);
    },
    get fallbackRoot() {
      return r.value ? r.value.fallbackRoot : D;
    },
    set fallbackRoot(l) {
      r.value && (r.value.fallbackRoot = l);
    },
    get fallbackFormat() {
      return r.value ? r.value.fallbackFormat : C;
    },
    set fallbackFormat(l) {
      r.value && (r.value.fallbackFormat = l);
    },
    get warnHtmlMessage() {
      return r.value ? r.value.warnHtmlMessage : _;
    },
    set warnHtmlMessage(l) {
      r.value && (r.value.warnHtmlMessage = l);
    },
    get escapeParameter() {
      return r.value ? r.value.escapeParameter : v;
    },
    set escapeParameter(l) {
      r.value && (r.value.escapeParameter = l);
    },
    t: xe,
    getPostTranslationHandler: j,
    setPostTranslationHandler: X,
    getMissingHandler: re,
    setMissingHandler: Re,
    rt: ke,
    d: Ke,
    n: ae,
    tm: Fe,
    te: Be,
    getLocaleMessage: je,
    setLocaleMessage: Xe,
    mergeLocaleMessage: Me,
    getDateTimeFormat: ct,
    setDateTimeFormat: Je,
    mergeDateTimeFormat: qe,
    getNumberFormat: ve,
    setNumberFormat: he,
    mergeNumberFormat: Ee
  };
  function Qe(l) {
    l.locale.value = u.value, l.fallbackLocale.value = c.value, Object.keys(m.value).forEach((i) => {
      l.mergeLocaleMessage(i, m.value[i]);
    }), Object.keys(E.value).forEach((i) => {
      l.mergeDateTimeFormat(i, E.value[i]);
    }), Object.keys(g.value).forEach((i) => {
      l.mergeNumberFormat(i, g.value[i]);
    }), l.escapeParameter = v, l.fallbackFormat = C, l.fallbackRoot = D, l.fallbackWarn = I, l.missingWarn = N, l.warnHtmlMessage = _;
  }
  return Mn(() => {
    if (e.proxy == null || e.proxy.$i18n == null)
      throw ge(Y.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const l = r.value = e.proxy.$i18n.__composer;
    t === "global" ? (u.value = l.locale.value, c.value = l.fallbackLocale.value, m.value = l.messages.value, E.value = l.datetimeFormats.value, g.value = l.numberFormats.value) : s && Qe(l);
  }), Ie;
}
Il();
__INTLIFY_JIT_COMPILATION__ ? _n(Nl) : _n(pl);
ul(xa);
fl(Xn);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = _e();
  e.__INTLIFY__ = !0, za(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
function os(e) {
  const t = jr(), { t: n } = Lt(), a = typeof document < "u", s = H(a ? document.title : "");
  function r() {
    if (!e.meta.tabTitle && t.currentRoute.value.fullPath === e.fullPath) {
      console.warn("No tab title set for this route. If this is unintentional please set one on route.meta.tabTitle property", e.fullPath, e.meta);
      return;
    }
    if (a && document.title !== e.meta.tabTitle) {
      const o = e.meta.tabTitle;
      document.title = `Cluber - ${typeof o != "string" ? o : n(o)}`;
    } else
      document.title = s.value;
  }
  Se(e, () => r()), Mn(r);
}
function is(e, t) {
  return {
    storage: Hr("cluber", e, localStorage, {
      ...t
      // serializer: {
      //   read: (value: string) => {
      //     if (value) {
      //       const decrypted = useEncryption().decrypt(value)
      //       console.log('READ', value, decrypted)
      //       return decrypted ? JSON.parse(decrypted) : null
      //     }
      //     return null
      //   },
      //   write: (value: T) => {
      //     console.log('WRITE', value)
      //     return useEncryption().encrypt(JSON.stringify(unref(value)))
      //   },
      // },
    })
  };
}
const Hl = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric"
}, Yl = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit"
}, xl = {
  month: "long"
}, Kl = {
  month: "numeric"
}, Bl = {
  weekday: "long"
}, jl = {
  weekday: "long",
  day: "numeric"
}, Xl = {
  weekday: "short",
  day: "numeric"
}, Jl = {
  month: "short",
  day: "numeric"
}, ql = {
  day: "numeric"
}, Ql = {
  weekday: "short",
  year: "numeric",
  month: "short",
  day: "numeric"
}, Cn = {
  hour: "2-digit",
  minute: "2-digit"
}, _r = H("UTC");
function Zl(e) {
  return e.includes("+") ? _r.value : Intl.DateTimeFormat().resolvedOptions().timeZoneName;
}
function cs(e) {
  function t(a, s) {
    const r = Ir(a), o = s || Zl(a);
    return {
      full: () => r.toLocaleDateString(e, Hl),
      fullShort: () => r.toLocaleDateString(e, Ql),
      fullNumeric: () => r.toLocaleDateString(e, Yl),
      monthName: () => r.toLocaleDateString(e, xl),
      monthNumber: () => r.toLocaleDateString(e, Kl),
      monthFullShort: () => r.toLocaleDateString(e, Jl),
      dayName: () => r.toLocaleDateString(e, Bl),
      dayNumber: () => r.toLocaleDateString(e, ql),
      dayFull: () => r.toLocaleDateString(e, jl),
      dayFullShort: () => r.toLocaleDateString(e, Xl),
      hour: () => r.toLocaleTimeString(e, {
        ...Cn,
        timeZone: o
      }),
      hourWithSeconds: () => r.toLocaleTimeString(e, {
        ...Cn,
        second: "2-digit",
        timeZone: o
      })
    };
  }
  function n(a) {
    _r.value = a;
  }
  return {
    parseISODate: t,
    setGlobalUserTimezone: n
  };
}
const ze = H(), et = H(), Dn = tt.createHash("sha256").update(String(Kr())).digest("base64").substring(0, 32);
function us() {
  function e(s) {
    if (!ze.value || !et.value || !s)
      return "";
    const r = tt.createCipheriv(et.value, Dn, ze.value);
    let o = r.update(s, "utf-8", "hex");
    return o += r.final("hex"), o;
  }
  function t(s) {
    if (!ze.value || !et.value || !s)
      return "";
    const r = tt.createDecipheriv(et.value, Dn, ze.value);
    let o = r.update(s, "hex", "utf-8");
    return o += r.final("utf-8"), o;
  }
  function n() {
    return `${tt.randomBytes(32).toString("hex")}_${tt.randomBytes(16).toString("hex")}`;
  }
  function a({ initiVector: s, algorithm: r }) {
    ze.value = s, et.value = r;
  }
  return {
    encrypt: e,
    decrypt: t,
    generateKey: n,
    setEncryptionConfig: a
  };
}
const zl = {
  multiple: !1,
  accept: ["*"]
};
function fs(e = {}) {
  const t = H([]);
  let n;
  const a = {
    ...zl,
    ...e
  }, s = a.accept.map((u) => {
    const c = u.replace(/\//g, "\\$&").replace("*", ".+");
    return new RegExp(c);
  });
  function r() {
    n && (n.value = "", n.click());
  }
  function o(u) {
    t.value = t.value.filter((c) => c !== u);
  }
  return He(() => {
    document && (n = document.createElement("input"), n.type = "file", n.multiple = a.multiple, n.accept = a.accept.join(","), n.onchange = (u) => {
      const m = u.target.files, E = Array.from(m).filter((g) => s.some((N) => g.type.match(N)));
      t.value = a.multiple ? t.value.concat(E) : E;
    });
  }), Vt(() => {
    n == null || n.remove();
  }), {
    files: kn(t),
    open: r,
    remove: o
  };
}
function It(e, t) {
  const n = e.value.find((a) => a.types.includes(t));
  return {
    name: (n == null ? void 0 : n.address_components[0].long_name) || "",
    short_name: (n == null ? void 0 : n.address_components[0].short_name) || ""
  };
}
const es = "AIzaSyAJWkS9BG8zzka4Ia90SJ1Jxp7NMCAwbgc";
function ms(e = es) {
  const {
    coords: t,
    error: n,
    resume: a,
    pause: s
  } = xr({ immediate: !0 }), r = H([]), o = H(), u = q(() => It(r, "country")), c = q(() => It(r, "neighborhood")), m = q(() => It(r, "locality")), E = q(() => Number.isFinite(t.value.latitude) && Number.isFinite(t.value.longitude));
  return Se(t, () => {
    if (!n.value && E.value) {
      const g = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${t.value.latitude},${t.value.longitude}&key=${e}`;
      fetch(g).then((N) => N.json()).then((N) => {
        r.value = N.results;
      }).catch((N) => {
        o.value = N;
      }), s();
    }
  }, { immediate: !0 }), {
    geodata: r,
    country: u,
    locality: m,
    neighborhood: c,
    resume: a,
    pause: s
  };
}
function Pn(e) {
  const t = e.value;
  if (!t)
    return "";
  const n = t.textContent;
  return n ? n.trim() : "";
}
function _s(e) {
  const t = H("");
  return Yr(e, (n) => {
    n[0] && (t.value = Pn(e));
  }, {
    childList: !0,
    characterData: !0,
    attributes: !0,
    subtree: !0
  }), He(() => {
    t.value = Pn(e);
  }), {
    content: t
  };
}
export {
  br as Key,
  Un as mount,
  jl as timeFormatDayFull,
  Xl as timeFormatDayFullShort,
  Bl as timeFormatDayName,
  ql as timeFormatDayNumeric,
  Ql as timeFormatDayShort,
  Hl as timeFormatFull,
  Yl as timeFormatFullNumeric,
  Cn as timeFormatHour,
  Jl as timeFormatMonthFullShort,
  xl as timeFormatMonthName,
  Kl as timeFormatMonthNumber,
  ss as useBreakpoint,
  Kr as useBrowserFingerprint,
  os as useBrowserTabTitle,
  is as useCluberLocalStorage,
  cs as useDateLocale,
  us as useEncryption,
  fs as useFileDialog,
  ms as useGeolocation,
  ls as useInjectedSetup,
  as as useSetup,
  _s as useTextContent
};
//# sourceMappingURL=composables.es.js.map
